module.exports = __webpack_public_path__ + "img/fabrica-1.f63ac812.jpeg";